import { Stack, Tooltip, IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';

type Props = {
  row: any;
  onEdit: (id: string) => void;
  onQuickEdit?: (row: any) => void;
  onDelete: (id: string) => void;
  isEdit?: boolean;
  isDelete?: boolean;
  t: (key: string) => string;
};

export function RowCellWorkflowActions({
  row,
  onEdit,
  onQuickEdit,
  onDelete,
  isEdit = true,
  isDelete = true,
  t,
}: Props) {
  return (
    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
      {onQuickEdit && isEdit && (
        <Tooltip title={t('QUICK_EDIT')}>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onQuickEdit(row);
            }}
            sx={{ color: 'primary.main' }}
          >
            <Iconify icon="solar:pen-new-square-bold" width={18} />
          </IconButton>
        </Tooltip>
      )}
      {isEdit && (
        <Tooltip title={t('FULL_EDIT')}>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(row.id);
            }}
          >
            <Iconify icon="solar:pen-bold" width={18} />
          </IconButton>
        </Tooltip>
      )}
      {isDelete && (
        <Tooltip title={t('DELETE')}>
          <IconButton
            size="small"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(row.id);
            }}
            sx={{ color: 'error.main' }}
          >
            <Iconify icon="solar:trash-bin-trash-bold" width={18} />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
